
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import axios from 'axios'
import { Job, TranslationActivity } from '@/domains/global/models'
import { downloadFile } from '@/domains/global/functions/util'
import JobInfoTable from '@/domains/jobs/components/Read/JobInfoTable.vue'
import ActivityLine from './ActivityLine.vue'

@Component({
  components: { ActivityLine, JobInfoTable }
})
export default class ActivityList extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly activities!: TranslationActivity[]

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean

  @Prop({ type: Object as () => Job, required: true })
  readonly job!: Job

  get showActivityStatus () {
    return this.job.status === 'draft'
  }

  get headers() {
    if (this.showActivityStatus) {
      return ['Type of Document', 'Status']
    }

    return ['Type of Document']
  }

  downloadTranslatedDocuments() {
    const url = `${axios.defaults.baseURL}/jobs/${this.job.id}/download`
    downloadFile(url)
  }
}
